import { render, staticRenderFns } from "./Papers.vue?vue&type=template&id=5c86504e&scoped=true"
import script from "./Papers.vue?vue&type=script&lang=js"
export * from "./Papers.vue?vue&type=script&lang=js"
import style0 from "./Papers.vue?vue&type=style&index=0&id=5c86504e&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c86504e",
  null
  
)

export default component.exports